import React from 'react'
import {
  IProps as IFeatureSpotlightVertical,
  VerticalFeatureSpotlight,
} from 'marketing-site/src/library/components/VerticalFeatureSpotlight'
import { IFeatureSpotlightVertical as IContentfulFeatureSpotlightVertical } from 'marketing-site/@types/generated/contentful'
import { transformCTAWithBackground } from 'marketing-site/src/transformers/elements/ContentfulCTALink'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import * as Utils from 'marketing-site/src/library/utils'
import { transformImage } from '../elements/ContentfulImage'

export const ContentfulFeatureSpotlightVertical = (
  featureSpotlightVertical: IContentfulFeatureSpotlightVertical,
) => (
  <EntryMarker entry={featureSpotlightVertical}>
    {() => (
      <VerticalFeatureSpotlight {...transformFeatureSpotlightVertical(featureSpotlightVertical)} />
    )}
  </EntryMarker>
)

export function transformFeatureSpotlightVertical({
  fields,
}: IContentfulFeatureSpotlightVertical): IFeatureSpotlightVertical {
  return {
    ...fields,
    bgColor: Utils.getHexColorFromName(fields.backgroundColor),
    subheading: fields.subheadingRichText && documentToHtmlString(fields.subheadingRichText),
    imageRef: transformImage(fields.imageRef),
    mobileImage: fields.mobileImage && transformImage(fields.mobileImage),
    cta: fields.cta && transformCTAWithBackground(fields.cta),
    video: fields.video && fields.video.fields.file.url,
    videoWebm: fields.videoWebm && fields.videoWebm.fields.file.url,
  }
}
